export default {
  routes: [
    {
      name: 'notFound',
      path: '/:pathMatch(.*)*',
      meta: { layout: 'GuestLayout' },
      component: () => import('./views/NotFound.vue'),

    },
  ]
}
